import { declareString } from "@1js/localization";

export const SignInHeaderV2 = declareString("promptLibrary.signInHeaderV2", {
  text: "Sign in to unlock more features in Copilot Prompt Gallery",
  comment:
    "Text that appears on the landing page for Copilot Prompt Gallery in a temporary header with a sign in button.",
});

export const SignIn = declareString("promptLibrary.signIn", {
  text: "Sign in",
  comment:
    "Text that appears on the sign in button in the temporary header on the landing page for Copilot Lab and the sign in button in the prompt modal.",
});

export const SignInButtonLabel = declareString(
  "promptLibrary.signInButtonLabel",
  {
    text: "Sign in to access more prompt features button",
    comment: "Sign in button label for card and header sign in buttons.",
  }
);

export const SignInTextPromptDetail = declareString(
  "promptLibrary.signInTextPromptDetail",
  {
    text: "Sign in to access more prompt features",
    comment: "Text to encourage the user to sign in on the prompt detail page.",
  }
);

export const SignInToBookmark = declareString(
  "promptLibrary.signInToBookmark",
  {
    text: "Sign in to bookmark",
    comment: "Text to encourage the user to sign in to bookmark a prompt.",
  }
);
